import { render, staticRenderFns } from "./department-add.vue?vue&type=template&id=36b62470&scoped=true";
import script from "./department-add.vue?vue&type=script&lang=jsx";
export * from "./department-add.vue?vue&type=script&lang=jsx";
import style0 from "./department-add.vue?vue&type=style&index=0&id=36b62470&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "36b62470", null);
export default component.exports;